// import statesCanada from "provinces-ca";
export default function optionStateCodesCanada() {
	// let arr = [];
	// statesCanada.map((item, key) => {
	//   arr.push({
	//     value: item.abbreviation,
	//     label: item.name + " (" + item.abbreviation + ")",
	//   });

	//   return "";
	// });

	let arr = [
		{
			value: "ON",
			label: "Ontario (ON)",
			json: [
				{ label: "Barrie", value: "Barrie" },
				{ label: "Burlington", value: "Burlington" },
				{ label: "Saint Catharines", value: "Saint Catharines" },
				{ label: "Whitby", value: "Whitby" },
				{ label: "Cambridge", value: "Cambridge" },
				{ label: "Guelph", value: "Guelph" },
				{ label: "Kingston", value: "Kingston" },
				{ label: "Sudbury", value: "Sudbury" },
				{ label: "Ajax", value: "Ajax" },
				{ label: "Thunder Bay", value: "Thunder Bay" },
				{ label: "Waterloo", value: "Waterloo" },
				{ label: "Kanata", value: "Kanata" },
				{ label: "Pickering", value: "Pickering" },
				{ label: "Brantford", value: "Brantford" },
				{ label: "Niagara Falls", value: "Niagara Falls" },
				{ label: "Sarnia", value: "Sarnia" },
				{ label: "Newmarket", value: "Newmarket" },
				{ label: "Sault Sainte Marie", value: "Sault Sainte Marie" },
				{ label: "Peterborough", value: "Peterborough" },
				{ label: "Belleville", value: "Belleville" },
			],
		},
		{
			value: "QC",
			label: "Quebec (QC)",
			json: [
				{ label: "Alma", value: "Alma" },
				{ label: "Amos", value: "Amos" },
				{ label: "Baie-Comeau", value: "Baie-Comeau" },
				{ label: "Beaconsfield", value: "Beaconsfield" },
				{ label: "Beauharnois", value: "Beauharnois" },
				{ label: "Bécancour", value: "Bécancour" },
				{ label: "Beloeil", value: "Beloeil" },
				{ label: "Blainville", value: "Blainville" },
				{ label: "Boisbriand", value: "Boisbriand" },
				{ label: "Bois-des-Filion", value: "Bois-des-Filion" },
				{ label: "Boucherville", value: "Boucherville" },
				{ label: "Bromont", value: "Bromont" },
				{ label: "Brossard", value: "Brossard" },
				{ label: "Candiac", value: "Candiac" },
				{ label: "Cantley", value: "Cantley" },
				{ label: "Carignan", value: "Carignan" },
				{ label: "Chambly", value: "Chambly" },
				{ label: "Châteauguay", value: "Châteauguay" },
				{ label: "Côte-Saint-Luc", value: "Côte-Saint-Luc" },
				{ label: "Cowansville", value: "Cowansville" },
				{ label: "Deux-Montagnes", value: "Deux-Montagnes" },
				{ label: "Dolbeau-Mistassini", value: "Dolbeau-Mistassini" },
				{ label: "Dollard-Des Ormeaux", value: "Dollard-Des Ormeaux" },
				{ label: "Dorval", value: "Dorval" },
				{ label: "Drummondville", value: "Drummondville" },
				{ label: "Farnham", value: "Farnham" },
				{ label: "Gaspé", value: "Gaspé" },
				{ label: "Gatineau (Hull)", value: "Gatineau (Hull)" },
				{ label: "Granby", value: "Granby" },
				{ label: "Joliette", value: "Joliette" },
				{ label: "Kahnawake", value: "Kahnawake" },
				{ label: "Kirkland", value: "Kirkland" },
				{ label: "Lachute", value: "Lachute" },
				{ label: "L'Ancienne-Lorette", value: "L'Ancienne-Lorette" },
				{ label: "La Prairie", value: "La Prairie" },
				{ label: "L'Assomption", value: "L'Assomption" },
				{ label: "La Tuque", value: "La Tuque" },
				{ label: "Laval", value: "Laval" },
				{ label: "Lavaltrie", value: "Lavaltrie" },
				{
					label: "Les Îles-de-la-Madeleine",
					value: "Les Îles-de-la-Madeleine",
				},
				{ label: "Lévis", value: "Lévis" },
				{ label: "L'Île-Perrot", value: "L'Île-Perrot" },
				{ label: "Longueuil", value: "Longueuil" },
				{ label: "Magog", value: "Magog" },
				{ label: "Marieville", value: "Marieville" },
				{ label: "Mascouche", value: "Mascouche" },
				{ label: "Matane", value: "Matane" },
				{ label: "Mercier", value: "Mercier" },
				{ label: "Mirabel", value: "Mirabel" },
				{ label: "Mont-Laurier", value: "Mont-Laurier" },
				{ label: "Montmagny", value: "Montmagny" },
				{ label: "Montréal [Montreal]", value: "Montréal [Montreal]" },
				{ label: "Mont-Royal", value: "Mont-Royal" },
				{ label: "Mont-Saint-Hilaire", value: "Mont-Saint-Hilaire" },
				{ label: "Mont-Tremblant", value: "Mont-Tremblant" },
				{
					label: "Notre-Dame-de-l'Île-Perrot",
					value: "Notre-Dame-de-l'Île-Perrot",
				},
				{ label: "Pincourt", value: "Pincourt" },
				{ label: "Pointe-Claire", value: "Pointe-Claire" },
				{ label: "Pont-Rouge", value: "Pont-Rouge" },
				{ label: "Prévost", value: "Prévost" },
				{ label: "Québec [Quebec]", value: "Québec [Quebec]" },
				{ label: "Rawdon", value: "Rawdon" },
				{ label: "Repentigny", value: "Repentigny" },
				{ label: "Rimouski", value: "Rimouski" },
				{ label: "Rivière-du-Loup", value: "Rivière-du-Loup" },
				{ label: "Roberval", value: "Roberval" },
				{ label: "Rosemère", value: "Rosemère" },
				{ label: "Rouyn-Noranda", value: "Rouyn-Noranda" },
				{
					label: "Saguenay (Chicoutimi - Jonquière)",
					value: "Saguenay (Chicoutimi - Jonquière)",
				},
				{ label: "Saint-Amable", value: "Saint-Amable" },
				{
					label: "Saint-Augustin-de-Desmaures",
					value: "Saint-Augustin-de-Desmaures",
				},
				{ label: "Saint-Basile-le-Grand", value: "Saint-Basile-le-Grand" },
				{
					label: "Saint-Bruno-de-Montarville",
					value: "Saint-Bruno-de-Montarville",
				},
				{ label: "Saint-Charles-Borromée", value: "Saint-Charles-Borromée" },
				{ label: "Saint-Colomban", value: "Saint-Colomban" },
				{ label: "Saint-Constant", value: "Saint-Constant" },
				{ label: "Sainte-Adèle", value: "Sainte-Adèle" },
				{ label: "Sainte-Agathe-des-Monts", value: "Sainte-Agathe-des-Monts" },
				{ label: "Sainte-Anne-des-Plaines", value: "Sainte-Anne-des-Plaines" },
				{ label: "Sainte-Catherine", value: "Sainte-Catherine" },
				{ label: "Sainte-Julie", value: "Sainte-Julie" },
				{ label: "Sainte-Julienne", value: "Sainte-Julienne" },
				{ label: "Sainte-Marie", value: "Sainte-Marie" },
				{
					label: "Sainte-Marthe-sur-le-Lac",
					value: "Sainte-Marthe-sur-le-Lac",
				},
				{ label: "Sainte-Sophie", value: "Sainte-Sophie" },
				{ label: "Sainte-Thérèse", value: "Sainte-Thérèse" },
				{ label: "Saint-Eustache", value: "Saint-Eustache" },
				{ label: "Saint-Félicien", value: "Saint-Félicien" },
				{ label: "Saint-Georges", value: "Saint-Georges" },
				{ label: "Saint-Hippolyte", value: "Saint-Hippolyte" },
				{ label: "Saint-Hyacinthe", value: "Saint-Hyacinthe" },
				{
					label: "Saint-Jean-sur-Richelieu",
					value: "Saint-Jean-sur-Richelieu",
				},
				{ label: "Saint-Jérôme", value: "Saint-Jérôme" },
				{ label: "Saint-Lambert", value: "Saint-Lambert" },
				{ label: "Saint-Lazare", value: "Saint-Lazare" },
				{ label: "Saint-Lin - Laurentides", value: "Saint-Lin - Laurentides" },
				{ label: "Saint-Raymond", value: "Saint-Raymond" },
				{ label: "Saint-Sauveur", value: "Saint-Sauveur" },
				{
					label: "Salaberry-de-Valleyfield",
					value: "Salaberry-de-Valleyfield",
				},
				{ label: "Sept-Îles", value: "Sept-Îles" },
				{ label: "Shawinigan", value: "Shawinigan" },
				{ label: "Sherbrooke", value: "Sherbrooke" },
				{ label: "Sorel-Tracy", value: "Sorel-Tracy" },
				{ label: "Terrebonne", value: "Terrebonne" },
				{ label: "Thetford Mines", value: "Thetford Mines" },
				{ label: "Trois-Rivières", value: "Trois-Rivières" },
				{ label: "Val-des-Monts", value: "Val-des-Monts" },
				{ label: "Val-d'Or", value: "Val-d'Or" },
				{ label: "Varennes", value: "Varennes" },
				{ label: "Vaudreuil-Dorion", value: "Vaudreuil-Dorion" },
				{ label: "Victoriaville", value: "Victoriaville" },
				{ label: "Westmount", value: "Westmount" },
			],
		},
		{
			value: "NS",
			label: "Nova Scotia (NS)",
			json: [
				{ label: "Amherst", value: "Amherst" },
				{ label: "Antigonish", value: "Antigonish" },
				{ label: "Bridgewater", value: "Bridgewater" },
				{
					label: "Cape Breton (incl. Sydney)",
					value: "Cape Breton (incl. Sydney)",
				},
				{ label: "Halifax", value: "Halifax" },
				{ label: "Kentville", value: "Kentville" },
				{ label: "New Glasgow", value: "New Glasgow" },
				{ label: "Stellarton", value: "Stellarton" },
				{ label: "Truro", value: "Truro" },
				{ label: "Wolfville", value: "Wolfville" },
				{ label: "Yarmouth", value: "Yarmouth" },
			],
		},
		{
			value: "NB",
			label: "New Brunswick (NB)",
			json: [
				{ label: "Hampton", value: "Hampton" },
				{ label: "Saint Quentin", value: "Saint Quentin" },
				{ label: "Salisbury", value: "Salisbury" },
				{ label: "Saint Andrews", value: "Saint Andrews" },
				{ label: "Saint Leonard", value: "Saint Leonard" },
				{ label: "Plaster Rock", value: "Plaster Rock" },
				{ label: "Kedgwick", value: "Kedgwick" },
			],
		},
		{
			value: "MB",
			label: "Manitoba (MB)",
			json: [
				{ label: "Brandon", value: "Brandon" },
				{ label: "Dauphin", value: "Dauphin" },
				{ label: "Flin Flon", value: "Flin Flon" },
				{ label: "Morden", value: "Morden" },
				{ label: "Portage la Prairie", value: "Portage la Prairie" },
				{ label: "Selkirk", value: "Selkirk" },
				{ label: "Steinbach", value: "Steinbach" },
				{ label: "Thompson", value: "Thompson" },
				{ label: "Winkler", value: "Winkler" },
				{ label: "Winnipeg", value: "Winnipeg" },
			],
		},
		{
			value: "BC",
			label: "British Columbia (BC)",
			json: [
				{ label: "Prince George", value: "Prince George" },
				{ label: "Port Coquitlam", value: "Port Coquitlam" },
				{ label: "Chilliwack", value: "Chilliwack" },
				{ label: "North Vancouver", value: "North Vancouver" },
				{ label: "Vernon", value: "Vernon" },
				{ label: "West Vancouver", value: "West Vancouver" },
				{ label: "Penticton", value: "Penticton" },
				{ label: "Mission", value: "Mission" },
				{ label: "Campbell River", value: "Campbell River" },
				{ label: "Courtenay", value: "Courtenay" },
				{ label: "Duncan", value: "Duncan" },
				{ label: "Port Alberni", value: "Port Alberni" },
				{ label: "Parksville", value: "Parksville" },
				{ label: "Tsawwassen", value: "Tsawwassen" },
				{ label: "Terrace", value: "Terrace" },
				{ label: "Cranbrook", value: "Cranbrook" },
				{ label: "Pitt Meadows", value: "Pitt Meadows" },
				{ label: "Squamish", value: "Squamish" },
				{ label: "Fort Saint John", value: "Fort Saint John" },
				{ label: "Prince Rupert", value: "Prince Rupert" },
			],
		},
		{
			value: "PE",
			label: "Prince Edward Island (PE)",
			json: [
				{ label: "Alberton", value: "Alberton" },
				{ label: "Borden - Carleton", value: "Borden - Carleton" },
				{ label: "Charlottetown", value: "Charlottetown" },
				{ label: "Cornwall", value: "Cornwall" },
				{ label: "Georgetown", value: "Georgetown" },
				{ label: "Kensington", value: "Kensington" },
				{ label: "Montague", value: "Montague" },
				{ label: "North Rustico", value: "North Rustico" },
				{ label: "O'Leary", value: "O'Leary" },
				{ label: "Souris", value: "Souris" },
				{ label: "Stratford", value: "Stratford" },
				{ label: "Summerside", value: "Summerside" },
			],
		},
		{
			value: "SK",
			label: "Saskatchewan (SK)",
			json: [
				{ label: "Nipawin", value: "Nipawin" },
				{ label: "Warman", value: "Warman" },
				{ label: "La Ronge", value: "La Ronge" },
				{ label: "Assiniboia", value: "Assiniboia" },
				{ label: "Rosetown", value: "Rosetown" },
				{ label: "Moosomin", value: "Moosomin" },
				{ label: "Esterhazy", value: "Esterhazy" },
				{ label: "Maple Creek", value: "Maple Creek" },
				{ label: "Unity", value: "Unity" },
				{ label: "Biggar", value: "Biggar" },
				{ label: "Canora", value: "Canora" },
				{ label: "Outlook", value: "Outlook" },
				{ label: "Kamsack", value: "Kamsack" },
				{ label: "Wynyard", value: "Wynyard" },
				{ label: "Pilot Butte", value: "Pilot Butte" },
				{ label: "Watrous", value: "Watrous" },
				{ label: "Hudson Bay", value: "Hudson Bay" },
				{ label: "Shaunavon", value: "Shaunavon" },
				{ label: "Indian Head", value: "Indian Head" },
				{ label: "Dalmeny", value: "Dalmeny" },
			],
		},
		{
			value: "AB",
			label: "Alberta (AB)",
			json: [
				{ label: "Leduc", value: "Leduc" },
				{ label: "Okotoks", value: "Okotoks" },
				{ label: "Cold Lake", value: "Cold Lake" },
				{ label: "Brooks", value: "Brooks" },
				{ label: "Grand Centre", value: "Grand Centre" },
				{ label: "Strathmore", value: "Strathmore" },
				{ label: "Canmore", value: "Canmore" },
				{ label: "Wetaskiwin", value: "Wetaskiwin" },
				{ label: "Sylvan Lake", value: "Sylvan Lake" },
				{ label: "Lacombe", value: "Lacombe" },
				{ label: "Hinton", value: "Hinton" },
				{ label: "High River", value: "High River" },
				{ label: "Stony Plain", value: "Stony Plain" },
				{ label: "Whitecourt", value: "Whitecourt" },
				{ label: "Taber", value: "Taber" },
				{ label: "Morinville", value: "Morinville" },
				{ label: "Edson", value: "Edson" },
				{ label: "Innisfail", value: "Innisfail" },
				{ label: "Slave Lake", value: "Slave Lake" },
				{ label: "Banff", value: "Banff" },
			],
		},
		{
			value: "NL",
			label: "Newfoundland and Labrador (NL)",
			json: [
				{
					label: "Channel-Port aux Basques",
					value: "Channel-Port aux Basques",
				},
				{ label: "Bonavista", value: "Bonavista" },
				{ label: "Torbay", value: "Torbay" },
				{ label: "Botwood", value: "Botwood" },
				{ label: "Lewisporte", value: "Lewisporte" },
				{ label: "Springdale", value: "Springdale" },
				{ label: "Saint Anthony", value: "Saint Anthony" },
				{ label: "Wabana", value: "Wabana" },
				{ label: "Harbour Breton", value: "Harbour Breton" },
				{ label: "Wabush", value: "Wabush" },
				{ label: "Burgeo", value: "Burgeo" },
				{ label: "Gambo", value: "Gambo" },
				{ label: "Catalina", value: "Catalina" },
				{ label: "Stephenville Crossing", value: "Stephenville Crossing" },
				{ label: "Nain", value: "Nain" },
				{ label: "Hare Bay", value: "Hare Bay" },
				{ label: "Natuashish", value: "Natuashish" },
				{ label: "Hopedale", value: "Hopedale" },
				{ label: "Makkovik", value: "Makkovik" },
				{ label: "Rigolet", value: "Rigolet" },
			],
		},
		{
			value: "NT",
			label: "Northwest Territories (NT)",
			json: [
				{ label: "Aklavik", value: "Aklavik" },
				{ label: "Behchokǫ̀", value: "Behchokǫ̀" },
				{ label: "Délı̨nę", value: "Délı̨nę" },
				{ label: "Enterprise", value: "Enterprise" },
				{ label: "Fort Good Hope", value: "Fort Good Hope" },
				{ label: "Fort Liard", value: "Fort Liard" },
				{ label: "Fort McPherson", value: "Fort McPherson" },
				{ label: "Fort Providence", value: "Fort Providence" },
				{ label: "Fort Resolution", value: "Fort Resolution" },
				{ label: "Fort Simpson", value: "Fort Simpson" },
				{ label: "Fort Smith", value: "Fort Smith" },
				{ label: "Gamèti", value: "Gamèti" },
				{ label: "Hay River", value: "Hay River" },
				{ label: "Inuvik", value: "Inuvik" },
				{ label: "Norman Wells", value: "Norman Wells" },
				{ label: "Paulatuk", value: "Paulatuk" },
				{ label: "Sachs Harbour", value: "Sachs Harbour" },
				{ label: "Tsiigehtchic", value: "Tsiigehtchic" },
				{ label: "Tuktoyaktuk", value: "Tuktoyaktuk" },
				{ label: "Tulita", value: "Tulita" },
				{ label: "Ulukhaktok", value: "Ulukhaktok" },
				{ label: "Wekweètì", value: "Wekweètì" },
				{ label: "Whatì", value: "Whatì" },
				{ label: "Yellowknife", value: "Yellowknife" },
			],
		},
		{
			value: "YT",
			label: "Yukon (YT)",
			json: [
				{ label: "Carmacks", value: "Carmacks" },
				{ label: "Dawson", value: "Dawson" },
				{ label: "Faro", value: "Faro" },
				{ label: "Haines Junction", value: "Haines Junction" },
				{ label: "Mayo", value: "Mayo" },
				{ label: "Teslin", value: "Teslin" },
				{ label: "Watson Lake", value: "Watson Lake" },
				{ label: "Whitehorse", value: "Whitehorse" },
			],
		},
		{
			value: "NU",
			label: "Nunavut (NU)",
			json: [
				{ label: "Arctic Bay", value: "Arctic Bay" },
				{ label: "Arviat", value: "Arviat" },
				{ label: "Baker Lake", value: "Baker Lake" },
				{ label: "Cambridge Bay", value: "Cambridge Bay" },
				{ label: "Chesterfield Inlet", value: "Chesterfield Inlet" },
				{ label: "Clyde River", value: "Clyde River" },
				{ label: "Coral Harbour", value: "Coral Harbour" },
				{ label: "Gjoa Haven", value: "Gjoa Haven" },
				{ label: "Grise Fiord", value: "Grise Fiord" },
				{ label: "Igloolik", value: "Igloolik" },
				{ label: "Iqaluit", value: "Iqaluit" },
				{ label: "Kimmirut", value: "Kimmirut" },
				{ label: "Kinngait", value: "Kinngait" },
				{ label: "Kugaaruk", value: "Kugaaruk" },
				{ label: "Kugluktuk", value: "Kugluktuk" },
				{ label: "Naujaat[e]", value: "Naujaat[e]" },
				{ label: "Pangnirtung", value: "Pangnirtung" },
				{ label: "Pond Inlet", value: "Pond Inlet" },
				{ label: "Qikiqtarjuaq", value: "Qikiqtarjuaq" },
				{ label: "Rankin Inlet", value: "Rankin Inlet" },
				{ label: "Resolute", value: "Resolute" },
				{ label: "Sanikiluaq", value: "Sanikiluaq" },
				{ label: "Sanirajak", value: "Sanirajak" },
				{ label: "Taloyoak", value: "Taloyoak" },
				{ label: "Whale Cove	", value: "Whale Cove	" },
			],
		},
	];

	// console.log("state-1", arr);
	// console.log("state-2", arr1);
	return arr;
}
